import React, { useEffect } from 'react'

// ルートの遅延コンポーネントを事前に起動してキャッシュを温める
const RoutePrefetcher: React.FC = () => {
  useEffect(() => {
    // 軽量に主要ページをプリウォーム
    const warmUps = [
      import('@/pages/DemosPage'),
      import('@/pages/DocsPage'),
      import('@/pages/GalleryPage'),
      import('@/pages/AboutPage'),
    ]
    // 競合を避けるためエラーは無視
    Promise.allSettled(warmUps)
  }, [])

  return null
}

export default RoutePrefetcher


